module.exports = __webpack_public_path__ + "img/bg_m.523598e2.png";